// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__2mz_g","themeColor":"Switch_themeColor__1io5k","checked":"Switch_checked__1KY9Y","button":"Switch_button__1w3F6"};